import { Fragment, ReactElement, useMemo } from 'react';
import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';
import { getBaseUrl } from '../get-base-url';
import { useParams } from 'react-router-dom';
import EditNotificationsShared from '../../research-notifications/edit';

interface EditAnscNotificationsSharedProps {
  scope?: string;
  items?: BreadcrumbItem[];
}

const EditAnscNotificationsShared = ({
  scope,
  items,
}: EditAnscNotificationsSharedProps): ReactElement => {
  const params = useParams();
  const idCat = params.idCat || undefined;

  const baseUrl: string = useMemo(() => {
    return getBaseUrl(scope, idCat);
  }, [scope, idCat]);

  return (
    <Fragment>
      <EditNotificationsShared items={items} baseUrl={baseUrl} />
    </Fragment>
  );
};

EditAnscNotificationsShared.displayName = 'Edit Notifications Ansc component';

export default EditAnscNotificationsShared;
